export enum TypeOfUser {
    KMP = "KMP",
    Director = "BoardMember"
}